export default __webpack_public_path__ + "static/media/sherif-hamad-b.b09fb96a.jpeg";